export const notRequested = Symbol('notRequested');
export type NotRequested = typeof notRequested;
export const requested = Symbol('requested');
export type Requested = typeof requested;
